function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.493 15.363v0.157c-0.016 0.261-0.109 0.52-0.279 0.739l-0.111 0.125-8.107 8.107c-0.52 0.52-1.365 0.52-1.885 0-0.48-0.48-0.517-1.237-0.111-1.76l0.111-0.125 7.163-7.164-7.163-7.164c-0.48-0.48-0.517-1.237-0.111-1.76l0.111-0.125c0.48-0.48 1.236-0.517 1.76-0.111l0.125 0.111 8.107 8.107c0.24 0.24 0.369 0.549 0.388 0.864v0zM20.133 14.107h-14.173c-0.735 0-1.333 0.599-1.333 1.333 0 0.737 0.599 1.333 1.333 1.333h14.173c0.737 0 1.333-0.596 1.333-1.333 0-0.735-0.596-1.333-1.333-1.333z"
});

function SvgArrowForw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-forw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForw);
export default __webpack_public_path__ + "static/media/arrow-forw.c893373a.svg";
export { ForwardRef as ReactComponent };